<template >
  <swiper
    :effect="'cards'"
    :cardsEffect="{
      rotate: false,
      slideShadows: false,
    }"
    :direction="'vertical'"
    :pagination="{
      dynamicBullets: true,
    }"
    :autoplay="{
      delay: 2500,
      disableOnInteraction: false,
    }"
    :modules="modules"
    class="offerSlider"
    id="container"
  >
    <!-- <swiper-slide v-for="(image, index) in imagesList" :key="index">
      <img :src="image" alt="" />
    </swiper-slide> -->

    <swiper-slide>
      <img src="@/assets/img/sampel-img/s2.jpg" alt="" />
    </swiper-slide>
    <swiper-slide>
      <img src="@/assets/img/sampel-img/s3.jpg" alt="" />
    </swiper-slide>
    <swiper-slide>
      <img src="@/assets/img/sampel-img/s4.jpg" alt="" />
    </swiper-slide>
    <swiper-slide>
      <img src="@/assets/img/sampel-img/s5.jpg" alt="" />
    </swiper-slide>
  </swiper>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-cards";
import "swiper/css/effect-fade";
import { Autoplay, Pagination, EffectCards, EffectFade } from "swiper";
export default {
  name: "offerSlider",
  // props: {
  //   imagesList: Object,
  //   score: Number,
  //   scoreReference: Number,
  //   suggestion: Boolean,
  // },
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    return {
      modules: [Autoplay, Pagination, EffectCards, EffectFade],
    };
  },
};
</script>

<style lang="css" scoped>
@import url(@/assets/style/components/offerSlider/offerSlider.css);
</style>